// Angular imports
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

// 3rd party imports
import { plainToClass } from 'class-transformer';

// Rxjs imports
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

// Service imports
import { MPCacheRegistrationService } from '../../../_services/shared-services/mp-cache-registration-service';

// Constant imports
import { URLConstants } from '../../../_constants/url-constants';
import { CacheDuration } from '../../../_constants/cache-duration';

// Model imports
import { BatchParametersDto } from '../_models/cb-batches/batch-parameters-dto';
import { BatchDetailResultDto } from '../_models/cb-batches/batch-detail-result-dto';

@Injectable({
    providedIn: 'root'
})
export class CBBatchDetailService {
    constructor(
        private readonly httpClient: HttpClient,
        private readonly cacheRegistrationService: MPCacheRegistrationService
    ) {}

    getBatchDetail(params: BatchParametersDto): Observable<BatchDetailResultDto> {
        const url = `${URLConstants.ccCBBatchApiBaseUrl}/detail${params.getQueryString()}`;
        this.cacheRegistrationService.registerForCache(url, params.clearCache);
        const headers = this.cacheRegistrationService.getHttpRequestHeaders(url, CacheDuration.fifteenMinute);
        const options = { headers };

        return this.httpClient
            .get(url, options)
            .pipe(map((response: any) => plainToClass(BatchDetailResultDto, response)));
    }
}
